export const colorScheme = 'green';
export const brandDark = '#C6F6D5';
export const brandLight = '#48BB78';
